import { render, staticRenderFns } from "./ToggleDenseGrid.vue?vue&type=template&id=0abc1e6c"
import script from "./ToggleDenseGrid.vue?vue&type=script&lang=js"
export * from "./ToggleDenseGrid.vue?vue&type=script&lang=js"
import style0 from "./ToggleDenseGrid.vue?vue&type=style&index=0&id=0abc1e6c&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0abc1e6c')) {
      api.createRecord('0abc1e6c', component.options)
    } else {
      api.reload('0abc1e6c', component.options)
    }
    module.hot.accept("./ToggleDenseGrid.vue?vue&type=template&id=0abc1e6c", function () {
      api.rerender('0abc1e6c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/TradeWatcher/ToggleDenseGrid.vue"
export default component.exports